import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlbums: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlbums"><Path d="M3.5 5.5V18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 20.5V3.5L20.5 5.5V18.5L11.5 20.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlbums;
